export default class TwoStepRequiredError<Data = unknown> extends Error {
  name = 'TwoStepRequiredError';

  constructor(message: string, data?: Data) {
    super(message);
  }
}
